import './loader.css';
const Spinner = () => <div class="loader-load">
</div>;

export default Spinner;